import { SeriesProveedor } from "@/shared/actions/erp";
import { create } from "zustand";
export interface SerieRowKardex {
  id: number;
  serie: string;
};

interface UseModalKardexSeriesStoreState {
  open: boolean
  setOpen: (open: boolean) => void
  series: SerieRowKardex[]
  setSeries: (series: string[], movimientoInventario: SeriesProveedor) => void
  movimientoInventario: SeriesProveedor | null
}

export const useModalKardexSeriesStore = create<UseModalKardexSeriesStoreState>(set => ({
  open: false,
  setOpen(open) {
    set({ open })
  },
  series: [],
  setSeries(series, movimientoInventario) {
    const data = series.map((serie, index) => ({
      id: index,
      serie,
    }));

    set({
      series: data,
      movimientoInventario: movimientoInventario
    })

  },
  movimientoInventario: null,

}))